(function () {
  'use strict';

  angular
    .module('pairingAssignmentComplementConfirmationModal')
    .service('pairingAssignmentComplementConfirmationModalService', pairingAssignmentComplementConfirmationModalService);

  function pairingAssignmentComplementConfirmationModalService(CommonMasterData, RemoteService) {
    var vm = this;

    vm.saveCrewRequirementsByPairingId = function (params, successFn, errorFn) {
      RemoteService.saveCrewRequirementsByPairingId(params).then(
        function (response) {
          console.log(response);
          successFn(response);
        },
        function (error) {
          console.log(error);
          errorFn(error.msg);
        }
      );
    }

  }
}());
